import React, { useState, useEffect } from 'react';
import { Box, TextField, Typography, Card, CardContent, Avatar } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';

// Mock function to simulate fetching user data (Replace with actual API call)
// const fetchUserProfile = (keycloak) => {
//   console.log(keycloak.idToken)
//   if (keycloak.idToken){
//     return Promise.resolve({
//       username: keycloak.idTokenParsed.preferred_username,
//       email: keycloak.idTokenParsed.email,
//       firstName: keycloak.idTokenParsed.given_name,
//       lastName: keycloak.idTokenParsed.family_name,
//       avatar: '',  // Empty avatar URL for initials fallback
//     });
//   } else {
//     keycloak.loadUserProfile(()=>{
//       console.log('Account Service');
//       return Promise.resolve({
//         username: keycloak.profile.username,
//         email: keycloak.profile.email,
//         firstName: keycloak.profile.firstName,
//         lastName: keycloak.profile.lastName,
//         avatar: '',  // Empty avatar URL for initials fallback
//       });
//     }, ()=>{
//       console.log("Failed to retrieved user profile.")
//     })
//   }

// };

// Mock function to simulate saving user data (Replace with actual API call)
// const saveUserProfile = async (keycloak, profile) => {
//   const token = keycloak.token;
//   // Make a PUT request to Keycloak Admin API to update user profile
//   await fetch(`${keycloak.authServerUrl}/admin/realms/${keycloak.realm}/users/${profile.id}`, {
//     method: 'PUT',
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: `Bearer ${token}`,
//     },
//     body: JSON.stringify(profile),
//   });
// };

// Function to get initials from a username
const getInitials = (username) => {
  const nameParts = username.split(' ');
  const initials = nameParts.map(part => part[0]).join('');
  return initials.toUpperCase();
};

export default function ProfileEditPage() {
  const { keycloak } = useKeycloak();
  const [profile, setProfile] = useState({
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    avatar: '',
  });

  useEffect(() => {
    if (keycloak.authenticated) {
      console.log("Authenticated")
      keycloak.loadUserProfile().then(()=>{setProfile(keycloak.profile)});
    } else {
      console.log("not authenticated")
    }
  }, [keycloak]);

  const handleChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    const token = keycloak.token;
    // Make a PUT request to Keycloak Admin API to update user profile
    var response = await fetch(`${keycloak.authServerUrl}/admin/realms/${keycloak.realm}/users/${profile.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(profile),
    });
    console.log(response)
  };

  // useEffect(() => {
  //   // Fetch user profile data when component mounts
  //   fetchUserProfile(keycloak).then((data) => setProfile(data));
  // }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setProfile({ ...profile, [name]: value });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Save profile data
  //   saveUserProfile(profile).then(() => {
  //     alert('Profile updated successfully!');
  //   });
  // };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',  // Center vertically and horizontally
        minHeight: '100vh',
        backgroundColor: 'background.default',
        padding: { xs: 2, sm: 4 },
        overflow: 'auto',
      }}
    >
      <Card
        sx={{
          width: { xs: '90%', sm: '80%', md: '40%', lg: '35%' },  // Further reduced width for smaller screens
          padding: { xs: 2, sm: 3, md: 4 },
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
          borderRadius: '16px',
          maxHeight: '85vh',  // Reduced max height to fit smaller screens
          overflowY: 'auto',
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
            <Avatar
              src={profile.avatar || null}
              alt="User Avatar"
              sx={{
                width: { xs: 50, sm: 70, md: 80 },  // Reduced avatar size
                height: { xs: 50, sm: 70, md: 80 },
                backgroundColor: 'primary.main',
                color: '#fff',
                fontSize: { xs: '20px', md: '30px' },  // Adjusted font size for avatar initials
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
              }}
            >
              {!profile.avatar && getInitials(profile.username)} {/* Show initials if no avatar */}
            </Avatar>
          </Box>
          <Typography
            variant="h6"  // Reduced to h6 for smaller text
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              marginBottom: 2,
              color: 'text.primary',
              fontSize: { xs: '16px', md: '20px' },  // Adjusted font size
            }}
          >
            View Profile
          </Typography>
          <form onSubmit={handleSave}>
            <TextField
              disabled
              label="Username"
              name="username"
              value={profile.username}
              onChange={handleChange}
              fullWidth
              margin="normal"
              sx={{
                backgroundColor: 'background.paper',
                borderRadius: '8px',
                fontSize: { xs: '14px', md: '16px' },  // Smaller text field font size
              }}
            />
            <TextField
              disabled
              label="Email"
              name="email"
              value={profile.email}
              onChange={handleChange}
              fullWidth
              margin="normal"
              sx={{
                backgroundColor: 'background.paper',
                borderRadius: '8px',
                fontSize: { xs: '14px', md: '16px' },  // Smaller text field font size
              }}
            />
            <TextField
              disabled
              label="First Name"
              name="firstName"
              value={profile.firstName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              sx={{
                backgroundColor: 'background.paper',
                borderRadius: '8px',
                fontSize: { xs: '14px', md: '16px' },  // Smaller text field font size
              }}
            />
            <TextField
              disabled
              label="Last Name"
              name="lastName"
              value={profile.lastName}
              onChange={handleChange}
              fullWidth
              margin="normal"
              sx={{
                backgroundColor: 'background.paper',
                borderRadius: '8px',
                fontSize: { xs: '14px', md: '16px' },  // Smaller text field font size
              }}
            />

            <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 3 }}>
              {/* <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                sx={{
                  padding: '8px 16px',  // Reduced button padding
                  fontSize: { xs: '12px', md: '14px' },  // Smaller button text
                  borderRadius: '8px',
                  backgroundColor: '#007bff',
                  '&:hover': { backgroundColor: '#0056b3' },
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                }}
              >
                Save
              </Button> */}
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
